import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserService } from './user.service';
import { ToastrService } from 'ngx-toastr';
import { SnackbarService } from '../snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class RecordingsService {
  getRecordingInfoAtTime(examid: string, candidateno: string, time: any, secondView: boolean) {
    return this.http.get(`${environment.serviceurl}/recording/getrecordinginfoattime?examid=${encodeURIComponent(examid)}&candidateno=${encodeURIComponent(candidateno)}&time=${encodeURIComponent(time)}&token=${encodeURIComponent(this.userservice.getToken())}&secondView=${encodeURIComponent(secondView)}`).toPromise()
    .catch(
      (error) => {
        this.toastr.error(`${error.status} ${error.statusText}`);
        this.toastr.error(`${error.error}`);
        return;
      });
  }
 

  req_headers;

  constructor(private http: HttpClient, private userservice: UserService, private toastr: SnackbarService) {
    this.req_headers = new HttpHeaders({
      "content-type": "application/json",
      "accept": "application/json",
      "Authorization": `Bearer ${this.userservice.getToken()}`,
      "skip_token_interceptor": "true"
    });
  }

  async getRecordings(examid: string, candidateno: string = ""): Promise<{primaryViewVideos: any, secondViewVideos: any}> {
    // if (!candidateno) {
    //   return this.http.get(`${environment.serviceurl}/recording/getexamrecordingdetails?examid=${encodeURIComponent(examid)}&token=${encodeURIComponent(this.userservice.getToken())}`).toPromise()
    //     .catch(
    //       (error) => {
    //         this.toastr.error(`${error.status} ${error.statusText}`);
    //         this.toastr.error(`${error.error}`);
    //         return;
    //       });
    // }
    // else {
      const primaryViewVideos = await this.http.get(environment.serviceurl + `/recording/listvideos?examid=${encodeURIComponent(examid)}&candidateno=${encodeURIComponent(candidateno)}&secondView=false`, { headers: this.req_headers }).toPromise()
        .catch((error) => {
          this.toastr.error(`${error.status} ${error.statusText}`);
          this.toastr.error(`${error.error}`);
        });

        const secondViewVideos = await this.http.get(environment.serviceurl + `/recording/listvideos?examid=${encodeURIComponent(examid)}&candidateno=${encodeURIComponent(candidateno)}&secondView=true`, { headers: this.req_headers }).toPromise()
        .catch((error) => {
          this.toastr.error(`${error.status} ${error.statusText}`);
          this.toastr.error(`${error.error}`);
        });

        return {primaryViewVideos, secondViewVideos};
    // }
  }
  initiatedownload(examid: string, to: string): Observable<any> {
    var data = {
      to: to,
      examid: examid,
      token: `${encodeURI(this.userservice.getToken())}`
    }
    return this.http.post(`${environment.serviceurl}/recording/downloadexamvideos`, data,{ headers: this.req_headers });
  }

  getRecordingUrl(examid: string, candidateno: string, time: number, secondView: boolean): string {
    return `${environment.serviceurl}/recording/download?examid=${encodeURIComponent(examid)}&candidateno=${encodeURIComponent(candidateno)}&time=${encodeURIComponent(time)}&token=${encodeURIComponent(this.userservice.getToken())}&secondView=${encodeURIComponent(secondView)}`;
  }

  getRecordingPlayerUrl(examid: string, candidateno: string, time: number, secondView: boolean): Observable<any>{
    return this.http.get(`${environment.serviceurl}/recording/getdownloadurl?examid=${encodeURIComponent(examid)}&candidateno=${encodeURIComponent(candidateno)}&time=${encodeURIComponent(time)}&token=${encodeURIComponent(this.userservice.getToken())}&secondView=${encodeURIComponent(secondView)}`);
    //return {url: `${environment.serviceurl2}/recording/download?examid=${encodeURI(examid)}&candidateno=${encodeURI(candidateno)}&time=${encodeURI(time)}&token=${encodeURI(this.userservice.getToken())}`};
  }

  // checkmp4exists(examid: any, candidateno: any, time: any): Observable<any> {
  //   return this.http.get(`${environment.serviceurl}/recording/checkfileexists?examid=${encodeURI(examid)}&candidateno=${encodeURI(candidateno)}&time=${encodeURI(time)}&token=${encodeURI(this.userservice.getToken())}`)
  // }

  // downloadvideo(url:any)
  // {
  //   return this.http.get(url);
  // }
}
